import EmojiButton from './EmojiButton';

export default EmojiButton;
